import { Grid, InputAdornment } from "@material-ui/core";
import React from "react";

import { Form } from "../../../../components/form";
import { FormButton } from "../../../../components/form_button";
import { SelectInput } from "../../../../components/select_input";
import { TextInput } from "../../../../components/text_input";
import { IFormProps } from "../../../../core/models";
import { isPending } from "../../../../core/redux";
import { clientFormValidation, clientTypeOptions, EClientType, IClientForm, IClientType } from "../../data/entities";

interface IProps extends IFormProps<IClientForm> {}

export const ClientForm: React.FC<IProps> = (props: IProps) => {
  const { branch, submitTitle } = props;
  const loading = isPending(branch);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <Form<IClientForm>
          {...props}
          initialValues={{
            name: "",
            balance: 0,
            salary: 0,
            info: "",
            type: EClientType.BUYER,
          }}
          validationSchema={clientFormValidation}
        >
          {({ values }) => (
            <>
              <TextInput label="Ad" name="name" />

              <TextInput
                label="Balans"
                name="balance"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">AZN</InputAdornment>,
                }}
              />

              <TextInput
                label="Maaş"
                name="salary"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">AZN</InputAdornment>,
                }}
              />

              <TextInput label="Əlavə məlumat" name="info" />

              <SelectInput<IClientType>
                value={values.type}
                options={clientTypeOptions}
                name="type"
                label="Klient tipi"
                renderLabel={(a) => a.label}
              />

              <FormButton label={submitTitle} loading={loading} />
            </>
          )}
        </Form>
      </Grid>
    </Grid>
  );
};
